import {
  IpponButton,
  IpponCard,
  IpponHSpace,
  IpponIconTile,
  IpponText,
  IpponVSpace,
} from '@ippon-ui/react';

export type TrackingIndicator = {
  label: string;
  onClick: () => void;
};

export type TrackingToast = {
  kind: 'success' | 'failure';
  title: string;
  actionLabel: string;
  onAction: () => void;
  dismissLabel: string;
  onDismiss: () => void;
};

export const TrackingIndicatorComponent = ({
  label,
  onClick,
  dataSelector,
}: TrackingIndicator & { dataSelector: string }) => (
  <IpponButton
    color="neutral"
    variant="outline"
    size="small"
    onClick={onClick}
    iconLeft={{ name: 'hourglass', variant: 'outline' }}
    dataSelector={dataSelector}
  >
    {label}
  </IpponButton>
);

export const TrackingToastComponent = ({
  toast,
  dataSelector,
}: {
  toast: TrackingToast;
  dataSelector: string;
}) => (
  <div data-selector={dataSelector} style={{ maxWidth: 360 }}>
    <IpponCard size="small" shadow="l3">
      <IpponVSpace gap={12}>
        <IpponHSpace gap={12} align="middle">
          <IpponIconTile
            icon={{
              name: toast.kind === 'success' ? 'checkmark-circle' : 'alert-circle',
              variant: 'outline',
            }}
            color={toast.kind === 'failure' ? 'error' : undefined}
            size="small"
          />
          <IpponText variant="body" dataSelector={`${dataSelector}.title`}>
            {toast.title}
          </IpponText>
        </IpponHSpace>
        <IpponHSpace gap={16} align="middle">
          <IpponButton
            size="small"
            onClick={toast.onAction}
            dataSelector={`${dataSelector}.action`}
          >
            {toast.actionLabel}
          </IpponButton>
          <IpponButton
            color="neutral"
            variant="outline"
            size="small"
            onClick={toast.onDismiss}
            dataSelector={`${dataSelector}.dismiss`}
          >
            {toast.dismissLabel}
          </IpponButton>
        </IpponHSpace>
      </IpponVSpace>
    </IpponCard>
  </div>
);
